import $ from 'jquery';
import _ from 'underscore';
import { getStorage } from '../../../home24/helpers/storage-factory';
import * as commonTrackingHelper from '../../../home24-shared/tracking/common/helper';
import BaseView from '../../core/baseView';
import * as registry from '../../../home24/core/registry';

/**
 * see http://jira.home24.de/browse/REBOOT-16507 for details
 * after click on navigation link a cookie with proper data will be set
 * and on next page cookie content will be pushed to dataLayer
 */
export default BaseView.extend({
  events: {
    'click .navigation a': 'onTopNavigationClick',
    'click .sub-menu-2-filters a': 'onTopManualClick',
    'click .js-navigation-track-side a': 'onSideNavigationClick',
    'click .breadcrumbs a': 'onBreadcrumbClick',
    'click .js-navigation-track-visual a': 'onVisualNavigationClick',
    'click .js-navigation-track a, .js-navigation-track area':
      'onNavigationTrackClick',
    'filter-submit .ui-input-rangeslider': 'onRangeFilterSubmit',
    'change .js-navigation-track-filter-left-checkbox input[type=checkbox]':
      'onFilterCheckboxChange',
    'change .js-navigation-track-filter-left-select select':
      'onFilterSelectChange',
    'change .js-navigation-track-filter-top-select select':
      'onTopFilterSelectChange',
    'click .js-navigation-track-b2b-footer': 'onB2BFooterLinkClick',
    'click .cms-b2b-teaser__button': 'onB2BTeaserButtonClick',
    'click .single-product-view a': 'onTopsellerClick',
    'click .cms-b2b-contacts__email': 'onB2BContactsEmailClick',
    'click .js-assortment-category': 'onB2BAssortmentCategoryClick',
    'click .js-top-icons': 'onTopIconClick',
    'click .js-header-login-link': 'onHeaderLoginLinkClick'
  },

  // object that is pushed to dataLayer
  data: {},

  // name of cookie where data will be stored
  cookieName: 'GtmOnNavigation',

  initialize: function() {
    this.readCookie();
    this.setDefaultData();
  },

  setDefaultData: function() {
    this.data = {
      current_page: [
        location.protocol,
        '//',
        location.host,
        location.pathname
      ].join(''),
      current_page_type: commonTrackingHelper.getCurrentDataLayer().pageType,
      current_page_level: registry.get('categoryLevel')
        ? registry.get('categoryLevel')
        : 0,

      // which navigation the user has clicked on
      click_position: '',

      // name shown the user clicked on
      click_name: '',

      // is set after page reload
      click_destination_level: '',
      event: 'Navi_click'
    };
  },

  // universal method for CMS_Blocks
  onNavigationTrackClick: function(event) {
    var $container = $(event.currentTarget).closest('.js-navigation-track');
    var clickPositionValue = $container.data('tracking-click-position');
    var currentTagName = event.currentTarget.tagName;
    var sClickName = $container.data('tracking-click-name');

    /* istanbul ignore else */
    if (['A', 'AREA'].indexOf(currentTagName) !== -1) {
      this.setClickPosition(clickPositionValue, event.currentTarget);
      this.setClickName(event.target, sClickName);
      this.setCookie();
    }
  },

  onTopFilterSelectChange: function(event) {
    var $cT = $(event.currentTarget);

    this.data.click_position =
      'FilterTop' +
      $cT
        .closest('.js-navigation-track-filter-top-select')
        .data('filter-position');
    this.data.click_name =
      $cT.attr('name') + '_' + $cT.find(':selected').data('value');
    this.setCookie();
  },

  onFilterSelectChange: function(event) {
    var $cT = $(event.currentTarget);

    this.data.click_position =
      'FilterSide' +
      $cT
        .closest('.js-navigation-track-filter-left-select')
        .data('filter-position');
    this.data.click_name =
      $cT.attr('name') + '_' + $cT.find(':selected').data('value');
    this.setCookie();
  },

  onB2BFooterLinkClick: function(ev) {
    this.data.click_destination_level = 'b2b';
    this.data.click_name = 'Geschaeftskunden';
    this.data.click_position = 'footer';

    commonTrackingHelper.addToDataLayerForLinks(ev, this.data);
  },

  onB2BTeaserButtonClick: function(ev) {
    this.data.click_destination_level = '10';
    this.data.click_name = 'kostenlos_anmelden';
    this.data.click_position = 'Top Teaser';

    commonTrackingHelper.addToDataLayerForLinks(ev, this.data);
  },

  // REBOOT-20192
  onTopsellerClick: function(event) {
    var $cT = $(event.currentTarget);

    this.data.click_destination_level = '6';
    this.data.click_name = $cT.find('.name').attr('data-tip-title');
    this.data.click_position = 'Top Seller Teaser';
    this.setCookie();
  },

  // REBOOT-20191
  onB2BContactsEmailClick: function() {
    this.data.click_destination_level = 'Email_form';
    this.data.click_name = 'Kontakt';
    this.data.click_position = 'Kontakt';
    this.pushData(this.data);
  },

  // REBOOT-20190
  onB2BAssortmentCategoryClick: function(event) {
    var $cT = $(event.currentTarget);

    this.data.click_destination_level = '2';
    this.data.click_name = $cT.find('.cms-b2b-link__title').text();
    this.data.click_position = 'Sortiment Teaser';
    this.setCookie();
  },

  onFilterCheckboxChange: function(event) {
    var $cT = $(event.currentTarget);

    this.data.click_position =
      'FilterSide' +
      $cT
        .closest('.js-navigation-track-filter-left-checkbox')
        .data('filter-position');
    this.data.click_name = $cT.data('name') + '_' + $cT.data('value');
    this.setCookie();
  },

  onRangeFilterSubmit: function(event, data) {
    this.data.click_position = 'FilterSide' + data.filterPosition;
    this.data.click_name = data.name + '_' + data.min + '-' + data.max;
    this.setCookie();
  },

  onTopNavigationClick: function(event) {
    var $cT = $(event.currentTarget);

    this.data.click_position = 'Top';
    this.setClickName(event.currentTarget);

    /*
         In case of 3nd level, override click_name to attach 2nd level name in front
         */
    if ($cT.hasClass('element')) {
      this.data.click_name =
        $cT
          .closest('.navigation-cell')
          .find('.header')
          .last()
          .text() +
        ' | ' +
        this.data.click_name;
    }

    this.setCookie();
  },

  onTopManualClick: function() {
    this.data.click_position = 'TopManual';
    this.setClickName('');
    this.setCookie();
  },

  onSideNavigationClick: function(event) {
    this.data.click_position = 'Side';

    this.setClickName(event.currentTarget);
    this.setCookie();
  },

  onBreadcrumbClick: function(event) {
    this.data.click_position = 'Breadcrumb';

    this.setClickName(event.currentTarget);
    this.setCookie();
  },

  onTopIconClick: function(event) {
    this.data.click_position = 'Top';
    this.data.click_name = $.trim(
      $(event.currentTarget)
        .find('.sprite-with-caption__caption')
        .text()
    );

    commonTrackingHelper.addToDataLayerForLinks(event, _.clone(this.data));
  },

  onHeaderLoginLinkClick: function(event) {
    this.data.click_position = 'Top';
    this.data.click_name = event.currentTarget.text.trim();

    commonTrackingHelper.addToDataLayerForLinks(event, _.clone(this.data));
  },

  /**
   * @param {String} clickPositionValue
   * @param {Object=} currentTarget
   */
  setClickPosition: function(clickPositionValue, currentTarget) {
    var $currentTarget = $(currentTarget);

    if ($currentTarget.data('tracking-click-position')) {
      this.data.click_position = $currentTarget.data('tracking-click-position');
    } else {
      this.data.click_position = clickPositionValue;
    }
  },

  onVisualNavigationClick: function(event) {
    this.setClickPosition('Visual', event.currentTarget);
    this.setClickName(event.currentTarget);
    this.setCookie();
  },

  /**
   * @param {Object} currentTarget
   * @param {String=} providedClickName
   */
  setClickName: function(currentTarget, providedClickName) {
    var $currentTarget = $(currentTarget);
    var clickName = $.trim($currentTarget.text());

    if ($currentTarget.data('tracking-click-name')) {
      this.data.click_name = $currentTarget.data('tracking-click-name');
    } else if (providedClickName && providedClickName.length > 0) {
      this.data.click_name = providedClickName;
    } else if (clickName && clickName.length > 0) {
      this.data.click_name = clickName;
    } else {
      this.data.click_name = 'CMS';
    }
  },

  setCookie: function() {
    getStorage().set(this.cookieName, JSON.stringify(this.data));
  },

  readCookie: function() {
    var cookieValue = getStorage().get(this.cookieName);

    if (cookieValue) {
      this.pushData($.parseJSON(cookieValue));
    }
  },

  pushData: function(data) {
    var clickDestination;
    var categoryLevel;
    var pageName = $('body').data('page');

    // check if on any level of catalog
    categoryLevel = registry.get('categoryLevel');

    if (typeof categoryLevel !== 'undefined') {
      clickDestination = categoryLevel;
    }

    // check if on PDP
    if (pageName === 'article') {
      clickDestination = 6;
    }

    // check if homepage
    if (pageName === 'index') {
      clickDestination = 0;
    }

    if (
      data.click_destination_level === '' &&
      typeof clickDestination !== 'undefined'
    ) {
      data.click_destination_level = clickDestination;
    }

    window.dataLayer.push(data);
    this.clearCookie();
  },

  clearCookie: function() {
    getStorage().unset(this.cookieName);
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/common/Navigation.js
 **/